import development from '../../config/development';
import test from '../../config/test';
import production from '../../config/production';
import { useRootProps } from '../components/UserDataProvider';

const configs = {
  development,
  test,
  production
};


export default () => {
  const { env } = useRootProps();

  if (env.match(/^dev/)) {
    return configs.development;
  }
  if (env.match(/^test/)) {
    return configs.test;
  }
  if (env.match(/^prod/)) {
    return configs.production;
  }
  // just in case
  return configs.production;
};
